import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './LoginPage.css';

const LoginPage = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setError(''); // Effacer l'erreur quand l'utilisateur tape
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        // Validation basique
        if (!formData.email || !formData.password) {
            setError('Veuillez remplir tous les champs');
            setLoading(false);
            return;
        }

        // Tentative de connexion
        const result = await login(formData.email, formData.password);

        if (result.success) {
            // Redirection vers le dashboard
            navigate('/dashboard');
        } else {
            setError(result.message);
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                
                <div className="login-card">
                    {/* Logo */}
                    <div className="login-header">
                        <div className="login-logo">
                            <span className="logo-icon">🎓</span>
                        </div>
                        <h1>Connexion</h1>
                        <p>Accédez à vos formations</p>
                    </div>

                    {/* Message d'information */}
                    <div className="info-message">
                        <span className="info-icon">💡</span>
                        <p>Si vous venez de vous inscrire, vérifiez votre email pour vos identifiants.</p>
                    </div>

                    {/* Formulaire */}
                    <form onSubmit={handleSubmit} className="login-form">
                        
                        {error && (
                            <div className="error-message">
                                ⚠️ {error}
                            </div>
                        )}

                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="votre@email.com"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password">Mot de passe</label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="••••••••"
                                required
                            />
                        </div>

                        <button type="submit" className="btn-login" disabled={loading}>
                            {loading ? 'Connexion...' : 'Se connecter'}
                        </button>

                        {/* Mot de passe oublié */}
                        <div className="forgot-password">
                            <Link to="/forgot-password">Mot de passe oublié ?</Link>
                        </div>

                    </form>

                    {/* Inscription */}
                    <div className="login-footer">
                        <p>Pas encore de compte ?</p>
                        <Link to="/register" className="link-register">
                            Créer un compte
                        </Link>
                    </div>

                    {/* Ou continuer sans compte */}
                    <div className="divider">
                        <span>ou</span>
                    </div>

                    <button 
                        onClick={() => navigate('/formations')} 
                        className="btn-browse"
                    >
                        Parcourir les formations sans compte
                    </button>

                </div>

            </div>
        </div>
    );
};

export default LoginPage;